import { useEffect, useRef, useState } from 'react';
import { diferenciaisData } from '@/mocks/homeData';

export default function Diferenciais() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="diferenciais"
      ref={ref}
      className="bg-white py-28 md:py-36 lg:py-44 border-t border-black/[0.04]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extralight text-black tracking-tight text-center mb-14 md:mb-20">
          {diferenciaisData.title}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {diferenciaisData.items.map((item, i) => (
            <div
              key={item.number}
              className={`${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              } transition-all duration-700 ease-editorial`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <span className="text-4xl md:text-5xl font-extralight text-terracota/40 tracking-tight block mb-5">
                {item.number}
              </span>
              <h3 className="font-display text-lg md:text-xl font-normal text-black tracking-tight mb-3">
                {item.title}
              </h3>
              <p className="font-body text-sm font-light text-brand-gray-body leading-[1.7]">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}